import ToggleSwitch from "../../../../common/Toggleswitch";

const VARIANT_STYLES = {
  default: {
    label: "text-[#17171C]",
    description: "text-[#6F6F7B]",
  },
  danger: {
    label: "text-red-600",
    description: "text-red-500",
  },
};

const ToggleField = ({
  label,
  description,
  name,
  checked,
  onChange,
  icon = null,
  variant = "default",
}) => {
  const styles = VARIANT_STYLES[variant] || VARIANT_STYLES.default;

  return (
    <div className="flex items-center justify-between py-3">
      <div>
        <div className={`flex items-center gap-2 text-sm font-medium ${styles.label}`}>
          {icon && <span className="flex-shrink-0">{icon}</span>}
          <span>{label}</span>
        </div>

        {description && (
          <div className={`text-xs mt-1 text-[#6F6F7B]`}>
            {description}
          </div>
        )}
      </div>

      <ToggleSwitch
        checked={checked}
        onChange={(value) => onChange(name, value)}
      />
    </div>
  );
};

export default ToggleField;
